import React, { useEffect, useState } from 'react'
import { styled } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ListProjectImagesApi } from '../../../axios/api'; // 👈 non-paginated API

function ProjectsList({ category = 'residential' }) {

  const [projectArray, setprojectArray] = useState([]);
  const navigate = useNavigate();

  const handleClick = (slug) => {
    navigate('/project/' + slug);
  };

  // Fetch ALL projects (non-paginated, same as homepage slider)
  useEffect(() => {
    axios.get(ListProjectImagesApi, {
      params: { category }
    }).then((response) => {
      const { data, StatusCode } = response.data.app_data;

      if (StatusCode === 6000) {
        // Missing categories are treated as residential for compatibility with
        // project data created before categories were introduced.
        const filtered = data.filter((project) => {
          const projectCategory = project?.project_category || 'residential';
          return projectCategory.toLowerCase() === category;
        });
        const reversed = [...filtered].reverse(); // latest first

        const pattern = [40, 24, 34, 28, 32, 38, 34, 40, 24];
        const Mobilepattern = [60, 39, 39, 60];

        let counter = 2;
        let current = 0;
        let mobileCurrent = 0;

        const mapped = reversed.map((obj) => {
          const temp = {
            ...obj,
            width: pattern[current],
            smWidth: Mobilepattern[mobileCurrent],
            id: counter
          };

          current = current + 1 === pattern.length ? 0 : current + 1;
          mobileCurrent =
            mobileCurrent + 1 === Mobilepattern.length ? 0 : mobileCurrent + 1;
          counter++;

          return temp;
        });

        setprojectArray(mapped);
      } else {
        setprojectArray([]);
      }
    });
  }, [category]);

  return (
    <Section>
      <ProjectListArea>
        {projectArray.map((obj) => (
          <SingleProject
            key={obj.id}
            w={obj.width}
            sm={obj.smWidth}
            onClick={() => handleClick(obj?.slug)}
          >
            <ImageContainer>
              <img
                loading="lazy"
                src={obj?.project_images?.[0]?.image}
                alt=""
              />
            </ImageContainer>
            <Name>
              <p>{obj?.title?.split(" for ")[1]}</p>
            </Name>
          </SingleProject>
        ))}
        {projectArray.length === 0 && (
          <EmptyState>
            No {category} projects have been added yet.
          </EmptyState>
        )}
      </ProjectListArea>
    </Section>
  );
}

export default ProjectsList;

const EmptyState = styled.p`
  width: 100%;
  margin: 40px 0 70px;
  text-align: center;
  font-family: 'raleway_regular';
`;


const Section = styled.div`
  @media(max-width:580px){
    width:100vw;
    margin-left:-5.5%;
  }
`;

const ProjectListArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  /* grid-template-columns: 40% 60%; */
  row-gap: 15px;
  margin:20px 0;

  @media(max-width:580px){
  row-gap: 5px;
  }
`;

const LoadButton = styled.div`
width: 100%;
margin: 0px 0px 25px;
display: flex;
justify-content: center;
align-items:center;

@media(max-width:1400px){
    margin: 40px 0px 25px;
    
}

button{
    border:1px solid var(--primary-cl);
    background-color: white;
    padding: 12px  26px;
    font-size:14px;
    font-family: 'raleway_medium';
    color: #000;

    &:hover{
        background-color: var(--primary-cl);
        color: #fff;
    }
}
`;

const SingleProject = styled.div`
cursor: pointer;
${(props) => props.w && `width:${props.w}%;`}

@media(max-width: 1024px){
  ${(props) => props.sm && `width:${props.sm}%;`}
}

@media(max-width: 900px){
  width: 49%;
}
@media(max-width:580px){
    width:100%;
    position: relative;
    &::after{
      content:'';
      position: absolute;
      inset: 0;
      background-color:#000;
      opacity: .3;
    }
}

@media(max-width:480px){
  width: 100%;
}

`;

const ImageContainer = styled.div`
width: 100%;
position: relative;
height: 90%;
max-height: 464px;
@media(max-width:580px){
  height: 100%;

}
    &:after{
        content: '';
        width: 0%;
        height: 100%;
        background-color: #c6c1c1;
        top: 0;
        left: 0;
        position: absolute;
        opacity: 25%;
        transition: all .2s ease;
    }
    &:hover{
        &:after{
            width: 100%;
            transition: all 1.1s ease;
        }
    }
img{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
}
`;

const Name = styled.div`
@media(max-width:580px){
    position: absolute;
    top: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    z-index: 25;
}
p{
margin-top: 12px;
font-family: 'raleway_medium';
margin-bottom:16px;

@media(max-width:1400px){
    font-size:14px;
}

@media(max-width:580px){
    color: #fff;
    font-size:21px;
    text-align:center;
}

@media(max-width:480px){
    margin-top: 8px;
}
@media(max-width:360px){
    width:17ch;
    font-size:19px;
  }

}
`;
